"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Row = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Row = ({ children, simple, small }) => {
    const items = Array.isArray(children) ? children : [children];
    const rowItems = [...items];
    return ((0, jsx_runtime_1.jsx)("div", { className: `row align-items-center g-0 ${simple ? "" : "col-md-6"} col-12 flex-md-nowrap`, children: rowItems.map((item, index) => {
            var _a;
            const colSize = Math.round(((_a = item.props.size) !== null && _a !== void 0 ? _a : 2) * (simple ? 1 : 2));
            const noPriorityItemClass = small ? "d-none" : "d-none d-md-block";
            const colSizeClass = small ? "col-6" : `col-md-${colSize}`;
            return ((0, jsx_runtime_1.jsx)("div", { className: `${item.props.priority ? "" : noPriorityItemClass} py-2 col ${colSizeClass} ${index > 0 ? "bordesr-start" : ""}`, children: item }, index));
        }) }));
}; // col-md-${Math.max(3,colSize/2)}
exports.Row = Row;
